import React from 'react';

const mediaArticles = [
  {
    title: "Gilgit-Baltistan's federal dependency",
    publication: "The News International",
    link: "https://www.thenews.com.pk/print/1008933-gilgit-baltistan-is-rising",
    description: "An article discussing the federal dependency of Gilgit-Baltistan and its implications for regional development and autonomy."
  },
  {
    title: "Gilgit-Baltistan is rising",
    publication: "The News International",
    link: "https://www.thenews.com.pk/print/906877-gilgit-baltistan-is-rising",
    description: "An opinion piece highlighting the emerging potential and progress of Gilgit-Baltistan in various sectors."
  },
  {
    title: "Walking the talk",
    publication: "The News International",
    link: "https://www.thenews.com.pk/print/719623-walking-the-talk",
    description: "A commentary on the importance of implementing policies effectively and bridging the gap between rhetoric and action."
  },
];

const mediaEngagement = [
  "Will Gilgit Baltistan Become Pakistan's 5th Province? Ft. Yasir Abbas | 196 | TBT",
  "Deciphering Gilgit-Baltistan Constitution | Policy Beats",
  "How Gilgit-Baltistan can Contribute to Pakistan's Economy?"
];

const mediaEngagementLinks = [
  "https://www.youtube.com/watch?v=kbCt5luurIY",
  "https://youtu.be/xeZzw7crwnA?si=8IgFi2Qehodkin1I",
  "https://youtu.be/KGaRIXPN9hM?si=SIC0NknXS9rebNEE"
];

const Media: React.FC = () => {
  return (
    <section id="media" className="bg-white section-padding">
      <div className="container-custom">
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2">
            Media & Public Engagement
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* News Papers Section */}
          <div className="mb-8">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">News Papers</h3>
            <ul className="space-y-4">
              {mediaArticles.map((article, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-prestige-600 mr-3 mt-1 text-base">•</span>
                  <div className="flex-1">
                    <div className="font-medium text-gray-800 text-base mb-1">{article.title}</div>
                    <div className="text-gray-600 text-sm mb-1">{article.publication}</div>
                    <div className="text-gray-600 text-xs mb-1">{article.description}</div>
                    <a 
                      href={article.link} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-prestige-600 hover:text-prestige-700 underline text-xs"
                    >
                      Read Article
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* Digital Media Section */}
          <div>
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Digital Media</h3>
            <ul className="space-y-2">
              {mediaEngagement.map((item, index) => (
                <li key={index} className="flex items-start">
                  <span className="text-prestige-600 mr-3 mt-1 text-base">•</span>
                  <div className="flex-1">
                    <div className="text-gray-800 text-sm mb-1">{item}</div>
                    <a 
                      href={mediaEngagementLinks[index]} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-prestige-600 hover:text-prestige-700 underline text-xs transition-colors duration-200"
                    >
                      {mediaEngagementLinks[index]}
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Media;
